window.addEventListener('load', function () {
  const maxAdditionalItems = 4;

  function updateNudgeText(additionalCount) {
    let nudge = document.querySelector('.bmsm-nudge-text');
    if (!nudge) return;
    let text = '';
    if (additionalCount === 0)      text = "Add 1 more item to get 5% OFF + Free Shipping 🤩";
    else if (additionalCount === 1) text = "Buy 1 more to get 10% OFF 🤩";
    else if (additionalCount === 2) text = "Buy 1 more to get 15% OFF 🤩";
    else if (additionalCount === 3) text = "Buy 1 more to get 20% OFF 🤩";
    else if (additionalCount >= 4)  text = "🎉 All rewards unlocked!";
    nudge.innerText = text;
  }

  async function syncUIWithCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      const isCartPage = window.location.pathname.includes('/cart');
      const qtyInput = document.querySelector('input[name="quantity"]');
      let mainQty = qtyInput ? parseInt(qtyInput.value) : 1;
      
      const mainVariantId = parseInt(document.querySelector('[name="id"]')?.value);
      const isMainInCart = cart.items.some(item => item.variant_id === mainVariantId);

      let totalForBar = cart.item_count;

      if (!isCartPage) {
        if (!isMainInCart) {
          totalForBar += mainQty;
        }
      }

      let additionalItemsCount = totalForBar > 0 ? totalForBar - 1 : 0;
      
      let percent = (Math.min(additionalItemsCount, maxAdditionalItems) / maxAdditionalItems) * 100;

      // Progress bar
      let bar = document.querySelector('.bmsm-progress-indicator');
      if (bar) {
        bar.style.width = percent + '%';
        bar.style.display = 'block';
        bar.style.transition = "width 0.4s ease-in-out";
      }

      // Wrapper class update
      let wrapper = document.querySelector('.bundles-collection___wrapper');
      if (wrapper) {
        let steps = [0, 25, 50, 75, 100];
        let closest = steps.reduce((prev, curr) => 
          Math.abs(curr - percent) < Math.abs(prev - percent) ? curr : prev
        );

        wrapper.classList.remove(
          'bundle-progress-0',
          'bundle-progress-25',
          'bundle-progress-50',
          'bundle-progress-75',
          'bundle-progress-100'
        );

        wrapper.classList.add(`bundle-progress-${closest}`);
      }

      // ✅ NEW: Milestone Active Logic
      document.querySelectorAll('.bmsm-tier-milestone').forEach((milestone, index) => {
        let stepPercent = (index + 1) * 25; // 25, 50, 75, 100

        if (percent >= stepPercent) {
          milestone.classList.add('active-step');
        } else {
          milestone.classList.remove('active-step');
        }
      });

      updateNudgeText(additionalItemsCount);

      let achievement = document.querySelector('.bmsm-achievement-text');
      if (achievement) achievement.style.display = additionalItemsCount >= 1 ? 'block' : 'none';

      // Bundle Buttons Sync
      document.querySelectorAll('.bundle-card').forEach(card => {
        let variantSelect = card.querySelector('.bundle-variant-select');
        let btn = card.querySelector('.discount-badge');
        if (!variantSelect || !btn) return;

        let vId = parseInt(variantSelect.value);
        let isInCart = cart.items.some(item => item.variant_id === vId);

        if (isInCart) {
          btn.innerText = 'REMOVE';
          btn.style.background = '#ff0101';
          variantSelect.disabled = true;
        } else {
          btn.innerText = 'ADD';
          btn.style.background = '#000000';
          variantSelect.disabled = false;
        }
      });

    } catch (e) { 
      console.error("Sync Error:", e); 
    }
  }

  document.addEventListener('click', async function (e) {
    let btn = e.target.closest('.discount-badge');
    if (!btn) return;

    let card = btn.closest('.bundle-card');
    let variantId = card.querySelector('.bundle-variant-select').value;
    let isRemoving = btn.innerText === 'REMOVE';
    let isCartPage = window.location.pathname.includes('/cart');

    btn.innerText = 'WAIT...';

    if (isRemoving) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });
    } else {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    }

    if (isCartPage) {
      window.location.reload(); 
    } else {
      syncUIWithCart(); 
    }
  });

  document.addEventListener('click', function (e) {
    let btn = e.target.closest('.your-cart-button-selector');
    if (btn) {
      e.preventDefault();
      window.location.href = '/cart';
    }
  }, true);

  if (window.location.pathname.includes('/cart')) {
    const cartObserver = new MutationObserver(() => {
      setTimeout(syncUIWithCart, 500); 
    });

    const cartContainer = document.querySelector('form[action="/cart"]') || document.body;
    cartObserver.observe(cartContainer, { childList: true, subtree: true });
    
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cart-item__remove, .remove, .quantity__button')) {
        setTimeout(syncUIWithCart, 800);
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.qtyBtn, .qty-btn, .minus, .plus')) {
      setTimeout(syncUIWithCart, 500);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.name === 'quantity') {
      syncUIWithCart();
    }
  });

  syncUIWithCart();
});